import { createUseAppMutation } from '@bos/api';

import { useAppSnackbar } from '../../../hooks/useAppSnackbar';
import { useI18nContext } from '../../../locale/i18n-react';
import { logUnhandledMutationError } from '../../logger/apiErrors/logUnhandledMutationError';

const useEnqueueErrorSnackbar = () => {
	const { enqueueSnackbar } = useAppSnackbar();
	return (message: string) => enqueueSnackbar({ variant: 'error', message });
};

export const useAppMutation = createUseAppMutation({
	useEnqueueErrorSnackbar,
	useDefaultErrorMessage: () => useI18nContext().LL.common.unexpectedApiError(),
	logUnhandledMutationError,
});
